<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid add-users">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Create system user</h4>
            <addUsersForm></addUsersForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import AddUsersForm from "./AddUsersForm.vue";
export default {
  name: "AddUsers",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    addUsersForm: AddUsersForm,
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageUsers",
        activeMenu: this.activeMenu ? this.activeMenu : "security",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.add-users {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
